import { render, staticRenderFns } from "./GetPaymentsXLS.vue?vue&type=template&id=597abbc8"
import script from "./GetPaymentsXLS.vue?vue&type=script&lang=js"
export * from "./GetPaymentsXLS.vue?vue&type=script&lang=js"
import style0 from "./GetPaymentsXLS.vue?vue&type=style&index=0&id=597abbc8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports